import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all categories
export const getCategories = async () => {
  try {
    const response = await api.get(`${API_URL}/category`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Add a new category
export const addCategory = async (category) => {
  try {
    const response = await api.post(`${API_URL}/category`, category,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Update a category
export const updateCategory = async (id, category) => {
  try {
    const response = await api.put(`${API_URL}/category/${id}`, category,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};


// Update an astrologer status
export const updateCategoryStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/category/status/${id}`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Delete a category
export const deleteCategory = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/category/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};
